module.exports = __webpack_public_path__ + "static/media/3.a0d4ffbc.png";